import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../packages/kiti/components/presentation/Text'

const ModalHeader = () => {
  const { t } = useTranslation(['publicToken', 'common'])
  const { id } = useModalData()

  const isEditing = id > 0

  const title = isEditing ? t('publicToken:editPublicToken') : t('publicToken:newPublicToken')

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
